export const GlobalStateReducer = (state, action) => {
    switch (action.type) {
        case 'RESTART_APP':
            return { ...state, resetID: Math.random(), asyncError: '' };
        case 'SET_ASYNC_ERROR':
            return { ...state, asyncError: action.data.asyncError };
        case 'SET_WARNING':
            return { ...state, warningMsg: action.data.warningMsg, warningAction : action.data.warningAction };
        default:
            return state;
    }
};

export const initialState = {
    asyncError: '',
    resetID: Math.random(),
    warningMsg: '',
    warningAction: () => {}
};



// WEBPACK FOOTER //
// ./src/components/global/reducers/GlobalStateReducer.js